{
  "name": "12-Sabat I JI Well Temperament",
  "description": "12-tone Rational Intonation Well Temperament, derived from harmonic partial row intervals limited to the prime subgroup of 2, 3, 17, 19 and 577. The seven diatonic notes are tuned Pythagorean, and the five whole tones are divided evenly using the higher primes. Conceived as an inversion of Vallotti's temperament with six pure fifths and six fifths narrowed by 1/6-Comma. Allows instruments at 415 Hz to play in 1/6-Comma meantone together with 440 Hz instruments tuned in JI.",
  "scale": [
    "17/16",
    "9/8",
    "81/68",
    "81/64",
    "4/3",
    "27/19",
    "3/2",
    "1731/1088",
    "27/16",
    "57/32",
    "243/128",
    "2/1"
  ],
  "key_colors_mode": "manual",
  "short_description": "12-WT-SabatI",
  "built_in_group": "12 Note Scales",
  "key_labels": "note_names",
  "note_names": ["C", "C", "D", "E", "E", "F", "F", "G", "G A", "A", "B", "B"],
  "note_colors": [
    "#ffd7d7",
    "#cfcfcf",
    "#ffffff",
    "#c6c6c6",
    "#ffffff",
    "#ffffff",
    "#ceeef6",
    "#ffffff",
    "#c6c6c6",
    "#ffffff",
    "#d6f7ff",
    "#ffffff"
  ],
  "equivSteps": 12,
  "fundamental": 440,
  "reference_degree": 9,
  "center_degree": 0,
  "rSteps": 2,
  "drSteps": 1,
  "hexSize": 42,
  "rotation": -16.102113751
}
